import { LocationQuery } from 'vue-router'

// Các key global và hằng số dùng chung
export const abTestGlobalKey = {
  activeCampaignKey: 'ab_test_v2_active_campaign',
  eventExprEntry: 'expr_entry',
  groupControl: 'control',
  groupTreatment: 'treatment',
  deviceMobile: 'mobile',
  deviceDesktop: 'desktop',
}

export type ABTestGroup =
  | typeof abTestGlobalKey.groupControl
  | typeof abTestGlobalKey.groupTreatment
  | string
  | undefined

/**
 * Interface mô tả các thông tin đầu vào cần thiết cho mỗi chiến dịch (campaign).
 */
export interface ABTestInputCondition {
  code: string
  exprId: string
  exprName: string

  startDate: string
  endDate: string
  stopDate: string

  endIfPurchased: boolean

  trafficRate?: number
  variants?: {
    code: ABTestGroup // Mặc định là control & treatment
    rate?: number // Mặc định là 50/50
  }[]

  allowedDevices?: string[]
  allowedCountries?: string[]
  allowedStores?: string[]
  allowedUrls?: string[]
  requiredUtms?: Record<string, string>[]
  excludeUtms?: Record<string, string>[]

  // Logic tùy chỉnh động (Optional)
  getDynamicMeta?: (
    runtime: ABTestUserActualCondition
  ) => { subExprId: string; subExprName: string } | null
  
  isTrack?: boolean // nếu false thì không gọi hàm trackEntry
  ipWhitelist?: string[] // Danh sách IP được miễn trừ (không tham gia test)

  // Hàm lấy các thuộc tính bổ sung để track (Optional)
  extraTracking?: () => Record<string, any>
}

/**
 * Các tham số runtime (điều kiện thực tế của thiết bị người dùng).
 */
export interface ABTestUserActualCondition {
  query?: LocationQuery
  deviceType?: string
  countryCode?: string
  referrer?: string
  isPurchased?: boolean
  ip?: string
}

/**
 * Thông tin đầu ra của AB Test.
 */
export interface ABTestOutput {
  variant: ABTestGroup
  assignedAt: number
  inTest: boolean
  subExprId: string
  subExprName: string
}

/**
 * Trạng thái tổng hợp của chiến dịch đang hoạt động.
 * Lưu trữ cả đầu vào (cấu hình) và đầu ra (kết quả phân loại).
 */
export interface ABTestActiveCampaignV2 {
  input: ABTestInputCondition
  output: ABTestOutput
  actualCondition: ABTestUserActualCondition
}

export const defaultIpWhitelist = ['127.0.0.1', '::1', 'localhost']